import api, { unwrap } from './client';

/* Journal d'audit — LECTURE SEULE.
   Aucune fonction d'écriture ici, et ce n'est pas un oubli : le serveur n'expose
   aucune route de modification ni de suppression (cf. backend/api/routes/audit.py).
   Réservé à l'admin plateforme, la garde est côté serveur. */

/** Une entrée de filtre vide ne doit PAS partir : `?module=` filtrerait sur la
    chaîne vide et ne ramènerait rien, ce qui se lit comme une panne. */
const query = (params) => {
  const q = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== null && v !== undefined && v !== '') q.append(k, v);
  });
  const s = q.toString();
  return s ? `?${s}` : '';
};

export const listAuditEvents = (params = {}) =>
  unwrap(api.get(`/audit/events${query(params)}`));

export const getAuditFilters = () => unwrap(api.get('/audit/filters'));

/** Le dernier usage de chaque utilisateur (sa dernière modification au
    journal), Administration › Gestion (2026-10-03). */
export const getLastActivity = () => unwrap(api.get('/audit/last-activity'));
